/* The server's clock, as far as this browser can tell (2026-09-28). A device clock that is
seconds off counted every round down against a different second from everybody else's: its
host turned the round early and was refused, and its non-host turned it "overdue" while the
server still saw time on it. So every game payload carries `server_time`, and every countdown
measures from `serverNow()` instead of the device.

A sample is the server's clock minus the time the message spent on the wire, so each one reads
the offset slightly low; the highest of the recent samples is the one that lost least to the
network. Recent, so a device whose clock is corrected mid-game catches up within a few payloads. */
const SAMPLES_KEPT = 10
let samples = []

function noteServerTime(serverTimeStr) {
  const serverMs = Date.parse(serverTimeStr ?? "")
  if (Number.isNaN(serverMs)) return
  samples = [...samples, serverMs - Date.now()].slice(-SAMPLES_KEPT)
}

function serverClockOffsetMs() {
  return samples.length ? Math.max(...samples) : 0
}

function serverNow() {
  return new Date(Date.now() + serverClockOffsetMs())
}

// For the tests: forget every sample.
function resetServerClock() {
  samples = []
}

function elapsedSecondsFromDateStr(dateStr) {
  const now = serverNow()
  const targetDate = new Date(dateStr)
  return Math.floor((now - targetDate) / 1000)
}

export { elapsedSecondsFromDateStr, noteServerTime, resetServerClock, serverClockOffsetMs, serverNow }
